// Model Tag Prefixes (AF_MAPPING_WORDS.md section 5, Robert I10 2026-10-21). Pure, no browser, no Firebase:
// shared by the survey, the Lists page and the server code.
//
// A tag record holds its SKM Type and number. The letters live here, as a Field List on the Lists page:
// Value = the prefix, Group = the SKM Type. Change a prefix (MTR to MTRL) and every tag of that type
// reads the new letters on the cards, the One-Line and the next export. The numbers never change.
// A new SKM Type is a build (the rules list the types). A new prefix for an existing type is not.

/** The SKM types a tag can be, with today's prefixes from Robert's SKM list (motors MTR, not MTRI). */
export const SKM_TYPES = [
  { type: "Utility", prefix: "UTIL" },
  { type: "Generator", prefix: "GEN" },
  { type: "Transformer", prefix: "XF2" },
  { type: "Bus", prefix: "BUS" },
  { type: "Cable", prefix: "CBL" },
  { type: "Protective Device", prefix: "PD" },
  { type: "Transfer Switch", prefix: "AUTO" },
  { type: "VFD", prefix: "VFD" },
  { type: "UPS", prefix: "UPS" },
  { type: "Motor", prefix: "MTR" },
  { type: "Load", prefix: "LOAD" },
  { type: "Filter", prefix: "FLTR" },
] as const;
export type SkmType = (typeof SKM_TYPES)[number]["type"];

/** The Lists page list that holds the prefixes. */
export const PREFIX_LIST = "Model Tag Prefixes";

/** A prefix the list may hold: capitals and digits, 2 to 6, starting with a letter. */
export const prefixOk = (p: string) => /^[A-Z][A-Z0-9]{1,5}$/.test(p);

export const isSkmType = (v: string): v is SkmType => SKM_TYPES.some((t) => t.type === v);

/** The note shown under each value on the Lists page. */
export const PREFIX_NOTE = "Tag letters for this SKM type. The numbers never change.";
